import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';

function AppReasonSearch({ setIssue, value, searchParam, error,className }) {
  const [openBN, setOpenBN] = React.useState(false);
  const [optionsBN, setOptionsBN] = React.useState([]);
  const loadingBN = openBN && optionsBN.length === 0;
  const [searchBN, setSearchBN] = React.useState('');
  const { t } = useTranslation('overview');
  const [loadingText, setLoadingText] = React.useState(t('lblSearchText'));
  React.useEffect(() => {
    let activeBN = true;
    if (openBN) {
      axios
        .get(
          `/GetSiriusIssueByProduct/${(searchBN || ' ')
            .toString()
            .toLocaleLowerCase(localStorage.i18nextLng_normalized)}/0`
        )
        .then(res => {
          if (activeBN) {
            if (res.data) {
              setOptionsBN(res.data);
            } else {
              setOptionsBN([]);
              setLoadingText(t('lblText'));
            }
          }
        })
        .catch(err => {
          setOptionsBN([]);
        });
    }
    return () => {
      activeBN = false;
    };
  }, [searchBN, openBN, loadingBN]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setSearchBN(searchParam);
    }
  }, [searchParam]);

  const updateIssue = item => {
    setIssue(item);
    value.Dsc = item.Dsc;
    value.Id = item.Id;
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={openBN}
      size="small"
      value={value}
      onOpen={() => {
        setOpenBN(true);
      }}
      onClose={() => {
        setOpenBN(false);
      }}
      getOptionLabel={option => {
        return option.Dsc;
      }}
      options={optionsBN}
      filterOptions={(optionsBN, state) => optionsBN}
      loading={loadingBN}
      loadingText={loadingText}
      onChange={(event, newValue) => {
        if (newValue && newValue.Dsc) {
          updateIssue(newValue);
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          size="small"
          className={className}  
          onChange={e => setSearchBN(e.target.value)}
          variant="outlined"
          required
          error={error}
          label={t('lblSelectAppType')}
          // helperText={value ? value.Dsc : ''}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingBN}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}

export default AppReasonSearch;
